import { SimpleGrid, Loader, Center } from '@mantine/core'
import MentorCard from '@/components/MentorCard'
import { UserWithMentor } from '@/types/mentor'
import classes from './MentorGrid.module.css'

export default function MentorGrid({ users, loading = false }: { users: UserWithMentor[], loading?: boolean }) {
  if (loading || !users) {
    return (
      <Center style={{ padding: '4rem' }} data-testid="mentor-grid-loading">
        <Loader size="lg" />
      </Center>
    )
  }
  
  if (users.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }} data-testid="mentor-grid">
        <p>No results</p>
      </div>
    )
  }

  return (
    <div className={classes.container} data-testid="mentor-grid">
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing={{ base: 'sm', sm: 'md', lg: 'xl' }}>
        {users.map((user, index) => (
          <MentorCard 
            key={user.id || index} 
            user={user} 
            priority={index < 3} // Prioritize first 3 cards (first row on desktop)
          />
        ))}
      </SimpleGrid>
    </div>
  )
}
